import { useEffect, useState } from "react";
import { listSystemQuests } from "utils/api";
import useSystemTicketState from "./useSystemTicketState";

export default function useSystemQuestGroups(soulId) {
  const ticket = useSystemTicketState(soulId);
  const [questGroups, setQuestGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let active = true;
    if (!soulId || ticket.isLoading) return () => { active = false; };
    if (ticket.isError) {
      setIsError(true);
      setIsLoading(false);
      return () => { active = false; };
    }
    if (!ticket.hasPurchased) {
      setQuestGroups([]);
      setIsLoading(false);
      return () => { active = false; };
    }

    const load = async () => {
      setIsLoading(true);
      try {
        const { data } = await listSystemQuests(soulId);
        if (active) setQuestGroups(data || []);
      } catch (error) {
        if (active) setIsError(true);
      } finally {
        if (active) setIsLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [soulId, ticket.hasPurchased, ticket.isLoading, ticket.isError]);

  return {
    questGroups,
    hasPurchased: ticket.hasPurchased,
    isLoading: ticket.isLoading || isLoading,
    isError: ticket.isError || isError,
  };
}
